import React, { useEffect, useState } from 'react'
import { Formik, Form } from 'formik'
import * as Yup from 'yup'
import FormikControl from '../../../../components/FormikControl/FormikControl';
import useSystemMasterList from '../../../../hooks/useSystemMasterList';
import useCordinates from '../../../../hooks/useCordinates';
import ComplaintImageCapture from './ComplaintImageCapture';
//import AddressInputComponent from '../../../../components/AppInput/AddressInputComponent';
import { useAlert } from '../../../../context/AlertContext';
import grievanceServices from '../grievanceServices';
import { CircularProgress, Dialog, DialogContent, Fade } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Add } from '@mui/icons-material';


function GrievanceForm() {

    const [masters,getMasterLabel] = useSystemMasterList(['grievance-type','grievance-status']);
    const {AppAlert} = useAlert();
    const [showForm ,setShowForm] = useState(false);
    
    const [imageFile,setImageFile] = useState(null);
    const [geolocationStatus,setGeoLocationStatus] = useState(true);

    const cordinates = useCordinates();

    const [saving,setSavingStatus] = useState(false);

    const initialValues = {
        complainantName	:'',
        phone:'',
        details:'',
        grievanceType:'',
        wardNo:'',
        address:'',
        addressHelper:'',
    }

    const validationRule = Yup.object({
        complainantName	: Yup.string().required("Required"),
        phone:Yup.string().required("Required").matches(/^[0-9]+$/, "Invalid Phone Number").min(10, 'Invalid Phone Number').max(10, 'Invalid Phone Number'),
        details: Yup.string().required("Required"),
        grievanceType: Yup.string().required("Required"),
    });


    const handleImageInput = (file) =>{
        setImageFile(file)
    }

    useEffect(()=>{
        if(navigator.geolocation){
			navigator.permissions.query({name:'geolocation'}).then(permissionStatus => {
				if (permissionStatus.state === 'denied') {
				    alert('Please allow location access.');
                    setGeoLocationStatus(false);
				}
			});
		}
    },[])

    const onSubmit = (values, { resetForm }) => {
        const payload = {
            ...values,
            phone: "91" + values.phone,
            latitude: cordinates?.latitude,
            longitude: cordinates?.longitude,
        };

        if (imageFile !== null) {
            payload.imageFile = imageFile;
        }

        setSavingStatus(true);
        grievanceServices.addNewGrievance(payload).then(res => {
            console.log(res);
            AppAlert("Your Complaint Registered Successfully");
            setShowForm(false);
            
            // 👉 Reset form inputs and image file ONLY on success
            resetForm();
            setImageFile(null);
            
        }).catch(error => {
            console.log(error);
            AppAlert("Something went wrong! Try again", "error");
        }).finally(() => {
            setSavingStatus(false);
        });
    };

    return (
        <>
            {!showForm  &&
            
                <button className="btn btn-primary" type="button" onClick={()=>setShowForm(true)} > <Add /> Grievance</button>
            
            }
            
            <Dialog
                open={showForm}
                keepMounted
                onClose={()=>setShowForm(false)}
                maxWidth="lg"
                fullWidth={true}
            >
                <DialogContent>
                
                <Formik
                    initialValues={initialValues}
                    validationSchema={validationRule}
                    onSubmit={onSubmit}
                    enableReinitialize validateOnMount
                >
                    {
                        (formik) => 
                            <Form>
                                <div className='card'>
                                    <div className='card-body'>
                                        <div className='row'>
                                            <div className='col-md-6 mb-3'>
                                                <FormikControl control="input" formik={formik} type="text" 
                                                    label="Complainant Name" name="complainantName" 
                                                    className="w-100 mb-3" 
                                                />
                                            </div>
                                            <div className='col-md-6 mb-3'>
                                                <FormikControl control="input" formik={formik} type="text" 
                                                    label="Complainant Phone No." name="phone" 
                                                    className="w-100 mb-3" 
                                                />
                                            </div>


                                            <div className='col-md-12'>
                                                <h5>Complaint Details</h5>
                                            </div>

                                            <div className='col-md-9 mb-3'>
                                                {masters && 
                                                    <FormikControl control="autoselect" formik={formik} 
                                                        label="Complaint About" name="grievanceType"  
                                                        options={masters['grievance-type']} multiple={false} 
                                                        className="w-100 mb-3" 
                                                    />
                                                }
                                            </div>

                                            <div className='col-md-3 mb-3'>
                                                <FormikControl control="input" formik={formik} type="text" 
                                                    label="Ward No" name="wardNo" 
                                                    className="w-100 mb-3"
                                                />
                                            </div>

                                            <div className='col-md-12 mb-3'>
                                                <FormikControl control="input" formik={formik} type="text" 
                                                    label="Complaint Details" name="details" 
                                                    multiline rows={2}
                                                    className="w-100 mb-3" 
                                                />
                                            </div>
                                            
                                        </div>
                                        <div className='row'>

                                            <div className='col-md-6 mb-3'>
                                                <h6>Complaint Photo</h6>
                                                <ComplaintImageCapture callback={handleImageInput} />
                                            </div>

                                            <div className='col-md-6 mb-3'>
                                                <FormikControl control="input" formik={formik} type="text" 
                                                    label="Address" name="address" 
                                                    multiline rows={2}
                                                    className="w-100 mb-3" 
                                                />
                                            </div>                                            
                                            
                                        </div>
                                    </div>
                                    <div className='card-footer'>
                                        {saving && 
                                            <div className='text-center'>
                                                Submiting your complaint please wait... 
                                                <span className=''><CircularProgress/></span>
                                            </div>
                                        }
                                        {!geolocationStatus && 
                                            <span className='text-danger'>Please Allow Location Access to Continue</span>
                                        }
                                        {!saving && 
                                            <button   disabled={!formik.isValid || !geolocationStatus}  className='btn btn-lg btn-success float-end' type='submit' > Add Grievance </button>
                                        }
                                        
                                    </div>
                                </div>
                            </Form>
                    }
                </Formik>
                </DialogContent>
        </Dialog>
        </>
    )
}

export default GrievanceForm